// extracted by css-extract-rspack-plugin
export default {"cls1":"JournalSubscriptionPage-cls1_1nt","cls2":"JournalSubscriptionPage-cls2_zqJ JournalSubscriptionPage-cls1_1nt"};